import { EMPTY_FIELD } from 'constants/emptyField';
import { Resources } from 'constants/resources';

import { useGetOne, useRecordContext } from 'react-admin';
import { Chip } from 'shared/mui/Chips';
import { LinearProgress } from 'shared/mui/LinearProgress/LinearProgress';
import { Commission } from 'types/embedded/commission';
import { Currency } from 'types/embedded/currency';

type Props = {
  onClick: (record?: Commission | undefined) => void;
  label?: string;
  source?: string;
};

export const RefundChargebackReportRuleField = ({ onClick }: Props): JSX.Element => {
  const commission = useRecordContext<Commission>();

  const { data: currency, isLoading: isLoadingCurrency } = useGetOne<Currency>(
    Resources.Currencies,
    { id: commission?.currency?.['@id'] || '' },
    {
      enabled: Boolean(commission?.currency),
    },
  );

  if (!commission) {
    return <>{EMPTY_FIELD}</>;
  }

  if (isLoadingCurrency) {
    return <LinearProgress />;
  }

  const getLabel = () => {
    const source = commission?.rate;

    const fix = source?.fix ? ` / FIX: ${source.fix}` : '';
    const percent = source?.percent ? ` / ${source.percent}%` : '';

    return `${currency?.alphaCode || ''}${fix}${percent}`;
  };

  return (
    <Chip color="primary" label={getLabel()} onClick={() => onClick(commission)} size="small" />
  );
};
